import { ExternalLink } from "lucide-react"

function Instructions({title, isEmail = false}: {title: string, isEmail?: boolean}) {

  const dnsSteps = [
    'Log into your domain registrar (where you bought the domain)',
    'Find the DNS management section',
    'Delete any existing A or CNAME records for @ and www',
    'Add the new records exactly as shown below',
    'Save changes and wait for propagation (5 minutes to 24 hours)',
  ]
  const emailSteps = [
    'Add these DNS records to your domain\'s DNS settings to verify ownership and enable email sending:',
    'Log into your domain registrar (where you bought the domain)',
    'Find the DNS management section',
    'Add the new records exactly as shown below',
    'Save changes and wait for propagation (5 minutes to 24 hours)',
  ]
  const steps = isEmail ? emailSteps : dnsSteps;

  return (
    <div className="bg-amber-50 dark:bg-amber-900/20 rounded-lg p-6 border border-amber-200 dark:border-amber-800/30 mb-4">
      <div className="flex items-center space-x-3 mb-4">
        <div className="p-2 bg-amber-500 rounded-lg">
          <ExternalLink className="size-5 text-white" />
        </div>
        <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100">
          DNS Configuration Required
        </h3>
      </div>
      <div className="space-y-3">
        <p className="text-gray-700 dark:text-gray-300">
          {title}
        </p>
        <ol className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          {steps.map((step, index) => (
            <li className="flex items-center space-x-2" key={index}>
              <span className="flex-shrink-0 w-6 h-6 bg-amber-500 text-white rounded-full flex items-center justify-center text-xs font-bold mt-0.5">{index + 1}</span>
              <span>{step}</span>
            </li>
          ))}
        </ol>
      </div>
    </div>
  )
}

export default Instructions